module.exports = __webpack_public_path__ + "static/img/guide03.e3ef9f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c22/guide03.png
// module id = Klrz
// module chunks = 0